import { render, staticRenderFns } from "./SponsorsMarquee.vue?vue&type=template&id=31aeb6ea&scoped=true"
import script from "./SponsorsMarquee.vue?vue&type=script&lang=js"
export * from "./SponsorsMarquee.vue?vue&type=script&lang=js"
import style0 from "./SponsorsMarquee.vue?vue&type=style&index=0&id=31aeb6ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aeb6ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
